<template>
  <div
    class="kejian"
    v-show="iframeQuickId||srcgame"
    :class="{'kejian_game':gameName}"
    :style="{ background: preClassTestBg }">
    <iframe
      v-if="srcgame"
      allowtransparency="true"
      :src="srcgame"
      class="iframe_game kejian-zindex'"
    ></iframe>
    <iframe
      v-else
      :class="{'kejian-zindex':byiframe!='https://about:blank' && loadData[qid] && loadData[qid].state}"
      allowtransparency="true"
      :src="byiframe"
      class="iframe_kejian"
    ></iframe>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import common from "common";
import utils from "utils";
import {IFly} from "limi-lib/dist/lib/limi/audio/IFly";
import OSS from "ali-oss";
export default {
  name: "kejian",
  data() {
    return {
      iframeSrc: "",
      getBrowserVersion: utils.getBrowserVersion(),
      byiframe: "https://about:blank",
      iframeState: false,
      qid: "",
      use_time: "",
      kejianJson: common.get("kejianJson"),
      srcgame: "", //小游戏url字段，只有当此字段有值时此组件会加载小游戏逻辑
      loadData: {},
      rightAnimation: '',
      wrongAnimation:'',
      loadTimer_game: null,
      loadCount: 0,
      RightAudioUrl: "", //答对音效
      WrongAudioUrl: "", //答错音效
      qLength:0,
      audio_time:0,
      OSSAudioQuestionPath:'',//语音题上传基本路径
      OSSDrawQuestionPath:"",//画图题上传基本路径
      drawing_filename:"",
      ifly:null,
      client:null,
      ossTick:null,
      closeTimeout:0,
      voiceInfo:'',//语音题信息
      flyGrade:null, //语音评测结果
      danmuObj: {
        //课前测结果文案配置对象
        1: "全部正确",
        2: "部分正确",
        3: "回答错误",
        4: "全部未答"
      },
      preClassTestBg: '', //课前测背景样式
    };
  },
  props: {
    gameIndex: {
      //小游戏标识字段
      type: String,
      default: ""
    },
    gameName: {
      //小游戏类型课件题对应小游戏名称
      type: String,
      default: ""
    },
    questionids: {
      type: String
    },
    iframeQuickId: {
      type: [Number, String],
      default: ""
    },
    iframeRight: {
      type: [Number],
      default: -1
    },
    answerType: {
      type: [String],
      default: ""
    },
    subType: {
      type: [String, Number],
      default: ""
    },
    type: {
      type: [String, Number],
      default: ""
    },
    unique_id: {
      type: [String, Number],
      default: ""
    },
    count: {
      type: Number
    },
    topicType:{
      // topicType=1  //直播发题
      // topicType=2  //回放发题
      // topicType=3  //作业发题
      // topicType=4  //作业解析
      // topicType=5  //作业订正
      // topicType=6  //学具乐园打开教具
      type:Number
    },
    //课后作业题目信息
    questionInfo:{
      type:Object,
    },
    timeOver: {
      type: Boolean,
      default: false
    },
    preClassTestBgImage: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState([
      "course_id",
      "lesson_id",
      "userID",
      "class_id",
      "COOK",
      "animation_dl_timeout",
      "animation_req_timeout",
      "animation_req_retry",
      "voiceSoe",
      "lastGrade",
      "class_type",
      "user_photo",
      "teacher_id",
      "realname"

    ])
  },
  created() {
    if (this.gameIndex) {
      this.loadGame();
      return;
    }
    this.uploadTestData();
    let kejianJson = common.get("kejianJson");
    if (kejianJson) {
      let cstime = 60 * 60 * 2; //2小时
      let time = Date.now();
      if (time - kejianJson.time > cstime) {
        common.remove("kejianJson");
      }
    }
    //获取所有课件题json
    this.getJson();
    this.$root.eventHub.$on("autoTurnPage",this.sendTestData);
  },
  mounted() {
    window.addEventListener("message", this.iframeMessage, false);
    this.loginCheck();
    // console.log('face-this.ifly:',this.);
  },
  methods: {
    ...mapActions(["getKejianJson","getOssToken","uploadOssSuccess"]),
    ...mapMutations(["downloadKeJianZip"]),
    uploadTestData() {
      let frontTest = common.get("frontTest") || [];
      let arr = [];

      for (let i = 0; i < frontTest.length; i++) {
        if (frontTest[i].deadTime < Date.now()) {
          frontTest.splice(i, 1);
          i--;
        }
      }

      frontTest.forEach(item => {
        let flag= !item.uploadSuccess &&
          item.lesson_id == this.lesson_id &&
        Number(item.qTime)+Number(item.qLength) - 3  < common.getTemServerTime();

        if (
         flag
        ) {
          arr.push({
            question_id: item.qid,
            unique_id: item.unique_id,
            data: item.qdata
          });
        }
      });

      common.set("frontTest", frontTest);
      if (arr.length > 0) {
        // console.log("课前测进行数据提交");
        this.$root.eventHub.$emit("sendPreQuestion", arr);
      }
    },
    loadGame() {
      clearTimeout(this.loadTimer_game);
      this.loadCount += 1;
      this.srcgame =
        common.API["800002"] +
        this.gameIndex +
        "/index.html" +
        this.createBaseParams();
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventWebViewInit",
        data: {
          unique_id: this.unique_id,
          qid: this.gameIndex,
          kejian_id:  3
        }
      });
      this.loadTimer_game = setTimeout(() => {
        this.srcgame = "";
        setTimeout(() => {
          console.log("小游戏第" + this.loadCount + "次加载失败，重新加载");
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventWebViewIndex",
            data: {
              unique_id: this.unique_id,
              qid: this.gameIndex,
              error:"index加载失败",
              kejian_id:  7
            }
          });
          if (this.loadCount == 2) {
            clearTimeout(this.loadTimer_game);
            this.$root.eventHub.$emit("loadGameFail");
            return;
          }
          this.loadGame();
        }, 200);
      }, this.animation_dl_timeout * 1000);
    },
    createSrc() {
      let urlParams = this.createBaseParams();
      if (!this.gameName) {
        this.iframeSrc = (common.API["800001"] || "http://live-qs-player.limiketang.com/index.html") + urlParams;
        // console.log(111, this.iframeSrc);
      } else {
        this.iframeSrc = common.API["800002"] + this.gameName + "/index.html" + urlParams;
      }
    },
    createBaseParams() {
      let env = common.get("configurl") || common.configurl;
      let strurl = "?";
      let urldata = {
        from: "h5",
        device:common.device,
        domain:window.location.origin,
        app_ver: '3.0.0',
        source: 'fd',
        lesson_id: this.lesson_id,
        COOK: this.COOK,
        version: this.getBrowserVersion,
        class_id: this.class_id,
        animation_req_timeout: this.animation_req_timeout,
        animation_req_retry: this.animation_req_retry,
        temp: Date.now(),
        networkEnvironment:env.name,
        topicType:this.topicType || 1,
        grade:this.gameIndex?this.lastGrade:-1,
        key: new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate()
          ).getTime() / 16,
        qid: "" //一定放到最后
      };
      for (let item in urldata) {
        strurl += item + "=" + urldata[item] + "&";
      }
      return strurl.slice(0, -1);
    },
    //暂停音频并销毁
    soundDestroy() {
      let audioList = window.audioList;
      if (!audioList) return;
      for (var i = 0; i < audioList.length; i++) {
        audioList[i].pause();
      }
      window.audioList = [];
    },
    /*
      创建音频并播放
      audioUrl:音频地址(String);loop:是否循环播放(Booleans)
      例:this.soundCreateAndPlay(soundUrl,true);
     */
    soundCreateAndPlay(soundName, loop) {
      if(!soundName)return;
      let audioUrl = common.API["800004"] + "/" + soundName;
      let needEndFn = false;
      if(soundName.includes('http')){
        audioUrl = soundName;
        needEndFn = true;
      }
      if (!window.audioList) {
        window.audioList = [];
      }
      let audioList = window.audioList;
      for (let i = 0; i < audioList.length; i++) {
        if (audioList[i].src == audioUrl) {
          audioList[i].pause();
          audioList[i] = null;
          audioList.splice(i,1)
        }
      }
      let sound = new Audio();
      sound.src = audioUrl;
      sound.loop = loop;
      sound.play();
      audioList.push(sound);
      if(needEndFn){
        const _self = this;
        if(!navigator.onLine){
          this.$emit('showToast',5);
          _self.iframePostMessage({
            etype: 94,
            qdata: this.src
          })
          return;
        }
        sound.onerror = function(){
          this.$emit('showToast',5);
          _self.iframePostMessage({
            etype: 94,
            qdata: this.src
          })
        }
        sound.onended = function(){
          _self.iframePostMessage({
            etype: 94,
            qdata: this.src
          })
        }
      }
    },
    getJson() {
      this.getKejianJson({ courseId: this.course_id }).then(({ res, ok }) => {
        if (!ok) return;
        let data = {
          time: Date.now(),
          data: res
        };
        this.kejianJson = data;
        common.set("kejianJson", data);
      });
    },
    /**
     * 收到indexSuccess成功后，向课件端发送题目数据
     */
    isHomeWork(){
      return  (this.topicType===3||this.topicType===4||this.topicType===5);
    },
    sendkejianData(pointdata) {
      this.loadData[pointdata.id].state = true;
      if(!this.isHomeWork()){
        window.clearTimeout(this.loadData[pointdata.id].interval);
      }
      let inrerval_85 = null;
      let num_85 = 0;
      let etype = 85;
      let qdata = "";
      try {
        qdata = this.kejianJson && this.kejianJson.data[pointdata.id];
      } catch (error) {
        //console.log('kejianError',error);
      }
      let sendData = {
        etype,
        qdata,
        animjson: ""
      };

      let sendData50 = {
        etype: 50,
        qdata:this.questionInfo
      }
      setTimeout(() => {
        this.isHomeWork() && this.iframePostMessage(sendData50);
        this.iframePostMessage(sendData);
      }, 0);
      if (!qdata) this.getJson();
      inrerval_85 = setInterval(() => {
        if (num_85 > 1 || !!qdata) {
          clearInterval(inrerval_85);
          num_85 = 0;
          return;
        }
        //console.log(11,'-',num_85)
        num_85++;
        try {
          this.isHomeWork() && this.iframePostMessage(sendData50);
          this.iframePostMessage(sendData);
        } catch (error) {}
      }, 1000);
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventWebViewIndex",
        data: {
          unique_id: this.unique_id,
          qid: pointdata.id,
          error:"index加载成功",
          kejian_id:  7
        }
      });
    },
    sendTestData(pointdata) {
      this.loadData[pointdata.id].state = true;
      if(!this.isHomeWork()){
        window.clearTimeout(this.loadData[pointdata.id].interval);
      }
      let inrerval_87 = null;
      let num_87 = 0;
      let etype = 87;
      let qdata = [];
      let nowLesson = {};
      try {
        let questionArr = this.questionids.split("_")[0].split(",");
        let qTime = this.questionids.split("_")[1];
        this.qLength = this.questionids.split("_")[2];
        let frontTest = common.get("frontTest") || [];

        let index = frontTest.findIndex(item => {
          return (
            item.lesson_id == this.lesson_id && item.unique_id == this.unique_id
          );
        });

        if (index == -1) {
          let temp = [];
          questionArr &&
            questionArr.forEach(item => {
              temp.push({
                qid: Number(item),
                sub_type: "",
                status: 0,
                coin: 0,
                answer: ""
              });
            });
          qdata = temp;

          frontTest.push({
            deadTime: Date.now() + 24 * 60 * 60 * 7 * 1000,
            uploadSuccess: false,
            qdata: temp,
            isDone: false,
            qid: this.iframeQuickId,
            qTime,
            qLength:this.qLength,
            unique_id: this.unique_id,
            lesson_id: this.lesson_id
          });
          common.set("frontTest", frontTest);
        } else {
          qdata = frontTest[index].qdata;
        }
      } catch (error) {
        console.log("kejianError", error);
      }
      // console.log(">>>qdata", qdata);
      let sendData = {
        etype,
        qdata: JSON.stringify(qdata)
      };

      setTimeout(() => {
        this.iframePostMessage(sendData);
      }, 0);
      if (!qdata) this.getJson();
      inrerval_87 = setInterval(() => {
        if (num_87 > 1 || !!qdata) {
          clearInterval(inrerval_87);
          num_87 = 0;
          return;
        }
        //console.log(11,'-',num_85)
        num_87++;
        try {
          this.iframePostMessage(sendData);
        } catch (error) {}
      }, 1000);
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventWebViewIndex",
        data: {
          unique_id: this.unique_id,
          qid: pointdata.id,
          error:"index加载成功",
          kejian_id:  7
        }
      });
    },
    // 讯飞语音识别
    getIfly(){
      if (!this.ifly) {
        this.ifly = new IFly();
        //讯飞连接成功
        this.ifly.addListener(IFly.SOCKET_OPEN, (e) => {
          this.iframePostMessage({etype: 100, show: "true"});
        });
        //声波
        this.ifly.addListener(IFly.WAVE, (e) => {
          // console.log('---->',e)
          this.iframePostMessage({etype: 98, qdata: e,show:"false"});
        });
        // 上传识别结果
        this.ifly.addListener(IFly.MESSAGE, (e) => {
          this.$emit('voiceStop', false);
          // console.log('-------识别结果------',e);
          if (e.code === undefined || e.code === "undefined") return;
          let audio_time = Math.floor(this.ifly.recorder.duration);
          let reg = /[\'\"]/g;
          let result = e.result || '';
          if (this.subType === 'I1') {
            result = result.replace(reg, "\'");
          } else if (this.subType === 'I2') {
            this.flyGrade = e.result;
            result = '语音评测题';
          }

          if(e.code!==0){
            // this.iframePostMessage({etype: 100});
            this.audio_time = audio_time;
            this.iframePostMessage({etype: 99, qdata: result});
            this.$root.eventHub.$emit("createLog", {
              id: "LMTrackEventVideoQSFailure",
              data: {
                q_id:this.qid,
                error_info:e.code,
                soe:this.subType === 'I2'?this.voiceSoe:""
              }
            });
            return;
          }
          if (audio_time<1) {
            this.$emit('showToast',3);
            this.iframePostMessage({etype: 100});
            return
          }
          // 10s内没有说话，提示
          if (result.trim() == '') {
            this.$emit('showToast',2)
            this.iframePostMessage({etype: 100});
            return;
          }
          this.audio_time = audio_time;
          this.iframePostMessage({etype: 99, qdata: result});
        });
        //讯飞socket连接失败
        this.ifly.addListener(IFly.SOCKET_ERROR, (e) => {
          this.$emit('showToast',4);
          this.iframePostMessage({etype: 100});
          this.$emit('voiceStop', false);
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventVideoQSFailure",
            data: {
              q_id:this.qid,
              error_info:e,
              soe:this.subType === 'I2'?this.voiceSoe:""
            }
          });
          //console.log('this.ifly socket connect error !');
        });
      }
      return this.ifly
    },
    upload2OSS(url,data,logData){
      data = Buffer.from(data.buffer);
      let params = {unique_id:this.unique_id}
      return this.client.put(url, data).then((res)=>{
        // 上传成功
        const logType = this.subType === "H1" ? "LMTrackEventOssDQuesImgUploadSuccess":"LMTrackEventVideoQSSuccess"
        this.subType!=="H1" && this.uploadOssSuccess(params);
        this.$root.eventHub.$emit("createLog", {
          id: logType,
          data: logData
        });
      }).catch((e) => {
        const logType = this.subType === "H1" ? "LMTrackEventOssDQuesImgUploadfail":"LMTrackEventVideoUploadFailure"
        logData.error_info = e;
        this.$root.eventHub.$emit("createLog", {
          id: logType,
          data: logData
        });
      });
    },
    _getOssToken(){
      this.getOssToken().then(({res,ok}) => {
        if(!ok)return;
        this.OSSAudioQuestionPath = `${res.Path}/${this.lesson_id}/`;
        this.OSSDrawQuestionPath = `${res.DrawingPath}/${this.lesson_id}/`
        this.client = new OSS({
          region: 'oss-cn-beijing',
          accessKeyId: res.AccessKeyId,
          accessKeySecret: res.AccessKeySecret,
          stsToken: res.SecurityToken,
          bucket: res.BucketName,
        });
        // client.useBucket(data.res.BucketName);
        // this.upload2OSS();
      }, () => {
        // 获取接口失败
      });
    },
    loginCheck(){
      this._getOssToken();
      this.ossTick = setInterval(() => {
        this._getOssToken()
      }, 1000 * 60 * 50);
      // this.getIfly().check().then(() => {
      //   console.log('成功')
      //   // todo success
      // }, (e) => {
      //   console.log('失败',e)
      //   // todo error
      // })
    },
    iframeMessage(rs) {
      let pointdata = rs.data;
      // console.log("接收消息->",pointdata.ctype,'pointdata->', pointdata);
      if (pointdata.ctype == "96") {
        this.getIfly().check().then(() => {
          let customData = JSON.parse(pointdata.custom_data);
          // this.$root.eventHub.$emit("videoMuted",true);
          this.voiceInfo = customData;
          if (this.subType === 'I1') {
            this.getIfly().start(false, customData.language);
          } else if (this.subType === 'I2') {
            this.getIfly().start(true, customData.language, 'ise', customData,this.voiceSoe);
          }
          this.$emit('voiceStop',false)
          }, (e) => {
            this.$emit('showToast',1);
            this.iframePostMessage({etype: 100});
            this.$root.eventHub.$emit("createLog", {
              id: "LMTrackEventVideoQSFailure",
              data: {
                q_id:this.qid,
                error_info:e,
                soe:this.subType === 'I2'?this.voiceSoe:""
              }
            });
            //console.log('失败',e);
        })
      }else if (pointdata.ctype == "97") {
        // this.$root.eventHub.$emit("videoMuted",false);
        this.$emit('voiceStop',true);
        this.getIfly().stop();
      }else if (pointdata.ctype == "95") {//播放声音
        this.soundCreateAndPlay(pointdata.soundName, pointdata.loop);
      }else if (pointdata.ctype == "1" && (pointdata.qidtype==3?this.qid == pointdata.qid:true)) {
        //答案
        let audio_filename="";
        let drawing_filename="";
        let time = parseInt((Date.now() - this.use_time) / 1000);
        let unique_id = this.unique_id;
        let audio_time = this.audio_time;
        let answerType = this.answerType;
        let qid = this.qid;
        let gameIndex = this.gameIndex;
        let subType = this.subType;
        let type = this.type;
        let voiceInfo = this.voiceInfo;
        if(audio_time){
          audio_filename = `${this.lesson_id}_${qid}_${this.userID}_${common.getTemServerTime()}.wav`;
          let logData = {
            q_id:qid+"",
            use_time:time,
            video_time:audio_time,
            answer:pointdata.answer,
            soe:this.subType === 'I2'?this.voiceSoe:""
          }
          this.upload2OSS(this.OSSAudioQuestionPath+audio_filename,this.ifly.recorder.getWAV(),logData);
        }
        if(this.subType==="H1"){
          drawing_filename = this.drawing_filename;
        }
        this.RightAudioUrl = pointdata.rightSound;
        this.WrongAudioUrl = pointdata.wrongSound;
        this.rightAnimation =  pointdata.rightAnimation;
        this.wrongAnimation =  pointdata.errorAnimation;
        this.closeTimeout = pointdata.timeout || 0;
        setTimeout(()=>{
          let answerDate = {
            audio_filename,  // 上传到阿里云的文件名
            audio_time, //语音题答题时长，单位为秒
            type,
            drawing_filename,// 上传到阿里云的文件名
            answer: pointdata.answer,
            quick_question_id: qid,
            use_time: time,
            answer_type: answerType,
            recv_unique_id: unique_id
          };
          if(subType === 'I1'){
            answerDate.answer = 'is_audio';
            answerDate.languages = voiceInfo.language;
          }
          //语音评测题默认展示答题动画
          if(subType=='I2'){
            answerDate.voice = {
              "isEn": this.flyGrade.isEn , //0英语,1汉语
              "completion": this.flyGrade.completion, //完整度
              "fluency": this.flyGrade.fluency, //流畅度
              "fullness":  this.flyGrade.fullness , //饱满度或准确度
              "star": this.flyGrade.star, //评星 单词使用 调用评测SDK失败 传 -1
              "isWord": this.flyGrade.isWord, //0单词,1句子
              "canal" : this.voiceSoe
            }
          }
          // console.log('评测：', answerDate)
          if(this.isHomeWork()){
            this.$emit("answerQuestion",pointdata)
          }else{
            this.$root.eventHub.$emit("answerQuestion", answerDate);
            if(unique_id!==this.unique_id)return;
            //关闭页面
            //console.log('关闭页面',pointdata,this.qid)
            this.$emit("closeIframe");
            this.byiframe = "https://about:blank";
            this.qid = "";
            this.audio_time = 0;
            this.drawing_filename = "";
            this.closeTimeout = 0;
            this.iframeState = false;
            this.$root.eventHub.$emit("createLog", {
              id: "LMTrackEventWebViewClose",
              data: {
                unique_id: unique_id,
                qid: qid || gameIndex,
                param: this.byiframe,
                kejian_id: 5
              }
            });
          }
        },this.closeTimeout * 1000)
      }else if (pointdata.ctype == "2") {
        let frontTest = common.get("frontTest") || [];
        let index = frontTest.findIndex(item => {
          return (
            item.unique_id == this.unique_id && item.lesson_id == this.lesson_id
          );
        });
        let qdata = frontTest[index].qdata;
        let index1 = qdata.findIndex(v => {
          return v.qid == JSON.parse(pointdata.custom_data).qid;
        });

        Object.assign(qdata[index1], JSON.parse(pointdata.custom_data));
        common.set("frontTest", frontTest);
      }else if (pointdata.ctype == "3") {
        this.$root.eventHub.$emit("precloseClock");
        //课前测结束
        let frontTest = common.get("frontTest") || [];
        let index = frontTest.findIndex(item => {
          return (
            item.unique_id == this.unique_id && item.lesson_id == this.lesson_id
          );
        });
        frontTest[index].isDone = true;
        this.$root.eventHub.$emit("sendPreQuestion", [
          {
            question_id: this.qid,
            unique_id: this.unique_id,
            data: frontTest[index].qdata
          }
        ]);
        common.set("frontTest", frontTest);
      }else if (pointdata.ctype == "90" && this.qid == pointdata.id) {
        //关闭页面
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventWebViewClose",
          data: {
            unique_id: this.unique_id,
            qid: this.qid || this.gameIndex,
            param: this.byiframe,
            kejian_id: 5
          }
        });
        //console.log('关闭页面',pointdata,this.qid)
        this.$emit("closeIframe", false);
        if (this.questionids && this.danmuObj[pointdata.custom_data]) {
          // AI自己组织弹幕上屏
          if(this.class_type === 9) {
            const data = {
              "answer_continuous": 0,
              "answer_level": 0,
              "avatar_url": this.user_photo,
              "class_id": this.class_id,
              "from_nickname": this.realname,
              "from_uid": this.userID,
              "lesson_id": this.lesson_id,
              "msg_body": {
                "id": 0,
                "img": "",
                "tag": "",
                "text": this.danmuObj[pointdata.custom_data],
                "text_img": "",
                "type": "3",
                "unique_id": "",
                "update_time": common.getTemServerTime()
              },
              "msg_type": 1,
              "srv_time": common.getTemServerTime(),
              "srv_utime": "",
              "stu_cli_time": common.getTemServerTime(),
              "student_id": this.userID,
              "teacher_id": this.teacher_id,
              "text_effect": 0
            }
            this.$emit('sendPreClassTestBarrage',data);
          }else {
            this.$root.eventHub.$emit("danmuSend", {
              type:3,
              id: this.qid,
              text: this.danmuObj[pointdata.custom_data]
            });
          }
        }
        this.byiframe = "https://about:blank";
        this.qid = "";
        this.audio_time = 0;
        this.drawing_filename = "";
        this.voiceInfo = "";
        this.iframeState = false;
      }else if (pointdata.ctype == "81" && this.qid == pointdata.id) {
        //动画执行
        this.use_time = Date.now();
        this.iframeState = true;
      }else if (pointdata.ctype == "86" && this.qid == pointdata.id) {
        //显示倒计时
        // console.log("86显示倒计时",pointdata)
        // 课前测背景处理
        const preClassTestBgImage = this.preClassTestBgImage;
        if(preClassTestBgImage) {
          this.preClassTestBg = `url(${preClassTestBgImage}) left top / 100% 100% no-repeat`;
        }

        if(this.isHomeWork()){
          window.clearTimeout(this.loadData[pointdata.id].interval);
          this.$emit("loadSuccess")
        }
        if (this.questionids) {
          this.$emit("countDown",  this.qLength-this.count<=5?this.qLength:this.count);
        } else {
          this.$emit("countDown", pointdata.custom_data);
        }
        this.gameName && this.$emit('loadGameSuccess')
      }else if (pointdata.ctype == "83") {
        //清除加载计时器
        // console.log("接收到83",this.questionids);
        if (this.gameIndex) {
          return;
        }
        if (this.questionids) {
          this.sendTestData(pointdata);
        } else {
          this.sendkejianData(pointdata);
        }
      }else if (pointdata.ctype == "88") {
        let qdata = this.kejianJson && this.kejianJson.data[pointdata.custom_data];
        setTimeout(() => {
          this.iframePostMessage({
            etype: 85,
            qdata: qdata || '',
            animjson: ""
          });
        }, 0);
      }else if (pointdata.ctype == "84") {
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventShowQuestion",
          data: {
            unique_id: this.unique_id,
            question_id: this.qid,
            reffer: this.source
          }
        });
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventWebViewInit",
          data: {
            unique_id: this.unique_id,
            qid: this.qid || this.gameIndex,
            url: this.byiframe,
            kejian_id: 3
          }
        });
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventWebViewStart",
          data: {
            unique_id: this.unique_id,
            qid: this.qid || this.gameIndex,
            url: this.byiframe,
            kejian_id: 4
          }
        });
        //console.log("接收到84");
        if (this.gameIndex) {
          setTimeout(() => {
            this.$root.eventHub.$emit("loadGameSuccess");
          }, 500);
          clearTimeout(this.loadTimer_game);
          return;
        }

        this.loadData[pointdata.id].state = true;
        setTimeout(() => {
          this.iframePostMessage({
            etype: 80
          });
        }, 0);
      }else if (pointdata.ctype == "66") {
        //记录日志
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventWebViewMarklog",
          data: pointdata.custom_data
        });
      }else if (pointdata.ctype == "68") {
        //记录埋点日志
        this.$root.eventHub.$emit("createLog", {
          id: pointdata.id,
          data: JSON.parse(pointdata.logData)
        });
      }else if (pointdata.ctype == "102" && this.qid == pointdata.id){
        //上传画板题图片
        this.drawing_filename = `${this.lesson_id}_${pointdata.id}_${this.userID}_${common.getTemServerTime()}.png`;
        const base64 = pointdata.custom_data.base64;
        const binary = window.atob(base64.split(",")[1])
        let array = []
        for (var i = 0, len = binary.length; i < len; i++) {
            array.push(binary.charCodeAt(i))
        }
        const u8Arr = new Uint8Array(array);
        const url = this.OSSDrawQuestionPath+this.drawing_filename;
        const logData = {
          q_id:pointdata.id+""
        }
        this.upload2OSS(url,u8Arr,logData);
      }
    },
    iframePostMessage(data) {
      //发送事件
      if (this.byiframe != "https://about:blank" || this.qid) {
        // let uri = "";
        // if (this.gameName) {
        //   uri = common.API["800002"] + this.gameName + "/index.html";
        // } else {
        //   uri = common.API["800001"] || "http://live-qs-player.limiketang.com/index.html";
        // }
        let ifr = document.getElementsByClassName("kejian-zindex")[0];
        if (!ifr) return;
        ifr.contentWindow.postMessage(data, "*");
        // console.log('发送消息=>',data)
        data.etype === 80 && this.xyiframePostMessage(data);
      }
    },
    xyiframePostMessage(data) {
      setTimeout(() => {
        if (!this.iframeState) {
          this.iframePostMessage(data);
        }
      }, 500);
    },
    loadIframe(v) {
      //加载课件题
      if (!this.loadData[v]) {
        this.$set(this.loadData, v, {
          interval: null,
          num: 0,
          state: false
        });
      }
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventWebViewInit",
        data: {
          unique_id: this.unique_id,
          qid: v,
          kejian_id:  3
        }
      });
      const time = this.isHomeWork() ? 10*1000:this.animation_dl_timeout * 1000;
      // console.log("进入第" + this.loadData[v].num + "次加载", this.qid);
      this.loadData[v].interval = setTimeout(() => {
        if (this.loadData[v].num === 1) {
          //第二次加载失败删除
          this.$emit("closeIframe");
          this.$set(this.loadData, v, {
            interval: null,
            num: 0,
            state: false
          });
          clearTimeout(this.loadData[v].interval);
          this.byiframe = "https://about:blank";
          console.log("第"+this.loadData[v].num+"次加载失败");
          this.$emit('loadErr')
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventWebViewIndex",
            data: {
              unique_id: this.unique_id,
              qid: v,
              error:"index加载失败",
              kejian_id:  7
            }
          });
          return;
        }
        this.loadData[v].num = 1;
        this.byiframe = "https://about:blank";
        setTimeout(() => {
          this.loadIframe(v);
          this.byiframe = this.iframeSrc + v;
        }, 200);
        console.log("第"+this.loadData[v].num+"次加载失败");
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventWebViewIndex",
          data: {
            unique_id: this.unique_id,
            qid: v,
            error:"index加载失败",
            kejian_id:  7
          }
        });
      }, time);
    }
  },
  watch: {
    timeOver(value) {
      if (value) {
        this.iframePostMessage({
          etype: 91
        });
      }
    },
    iframeQuickId(val, old) {
      this.createSrc();
      this.soundDestroy();
      this.qid = val;
      if (old) {
        clearTimeout(this.loadData[old].interval);
        this.getIfly().stop(false);
      }
      if (val === "") {
        //没有正在显示的课件题时，清空iframe阻断脚本继续加载
        this.byiframe = "https://about:blank";
        this.gameName = "";
        this.iframeState = false;
        return;
      }
      LIMI_ENV==='electron'&&this.downloadKeJianZip();
      this.loadIframe(val);
      this.byiframe = this.iframeSrc + val;
    },
    iframeRight(right) {
      if (right == 1) {
        this.RightAudioUrl && this.soundCreateAndPlay(this.RightAudioUrl, false);
      } else if (right == 0) {
        this.WrongAudioUrl && this.soundCreateAndPlay(this.WrongAudioUrl, false);
      }
    },
    preClassTestBgImage() {
      this.preClassTestBg = '';
    }
  },
  beforeDestroy(){
    clearInterval(this.ossTick);
    this.soundDestroy();
    window.removeEventListener("message", this.iframeMessage, false);
    this.$root.eventHub.$off("autoTurnPage")
    clearTimeout(this.loadTimer_game);
    if(this.ifly){
      this.ifly.stop(false);
      this.ifly.removeAllListeners(IFly.SOCKET_OPEN);
      this.ifly.removeAllListeners(IFly.WAVE);
      this.ifly.removeAllListeners(IFly.MESSAGE);
      this.ifly.removeAllListeners(IFly.SOCKET_ERROR);
    }
    if (this.gameIndex) {
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventLittleGameEnd",
        data: {
          game_id: this.gameIndex
        }
      });
    }
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.kejian {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 90;
  pointer-events: auto;
}
.kejian_game {
  z-index: 79;
}
.iframe_kejian {
  position: absolute;
  width: 100%;
  border: none;
  height: 100%;
  z-index: -1;
  opacity: 0;
  left: 0;
  top: 0;
}
.iframe_game {
  position: absolute;
  width: 100%;
  border: none;
  height: 100%;
  z-index: -1;
  opacity: 1;
  left: 0;
  top: 0;
}
.kejian-zindex {
  z-index: 90;
  opacity: 1;
}
.kejian-mask {
  width: 100vw;
  height: 100vh;
  position: fixed;
  pointer-events: auto;
  z-index: 70;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.25);
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/answer/kejian.vue